import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { useFormattedData } from './useResponseRatioGraph';

import type { ResponseRatioFilter, ResponseRatioItem } from '@/app/types/Dashboard';

interface Props {
	ascending?: boolean;
	filter?: ResponseRatioFilter;
	data: ResponseRatioItem[];
}

const ChartResponseRatio = ({ data = [], ascending = true, filter = 'all' }: Props) => {
	const sortedData = [...data].sort((a, b) => {
		if (filter === 'accepted') {
			return ascending ? a.accepted - b.accepted : b.accepted - a.accepted;
		}

		if (filter === 'declined') {
			return ascending ? a.rejected - b.rejected : b.rejected - a.rejected;
		}

		if (filter === 'unanswered') {
			return ascending ? a.unanswered - b.unanswered : b.unanswered - a.unanswered;
		}

		return ascending ? a.total - b.total : b.total - a.total;
	});

	const options = useFormattedData(sortedData, filter);

	return <HighchartsReact options={options} highcharts={Highcharts} />;
};

export default ChartResponseRatio;
